import { render } from "./Swipe.vue?vue&type=template&id=da740426&scoped=true&ts=true"
import script from "./Swipe.vue?vue&type=script&lang=ts"
export * from "./Swipe.vue?vue&type=script&lang=ts"

import "./Swipe.vue?vue&type=style&index=0&id=da740426&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da740426"]])

export default __exports__